import { useEffect, useState } from "react";
import { Token, URL_API } from "../../utils/Constant";
import axios from "axios";
import { toast } from "react-toastify";

interface SliderInterface {
    [key: string]: any;
}

const useSliderList = (refresh: boolean): SliderInterface[] => {
    const [sliders, setSliders] = useState<SliderInterface[]>([]);

    useEffect(() => {
        const fetchSliders = async () => {
            axios.get(`${URL_API}/slider-index`, {
                headers: {
                    Authorization: `Bearer ${Token}`
                }
            }).then(response => {

                if (response.status == 200) {
                    setSliders(response.data.slider);
                }

            }).catch(error => {
                if (error.status === 400) {
                    toast.info(error.data.message);
                }

                if (error.status === 500) {
                    toast.warning(error.data.message);
                }
            })
        };

        fetchSliders();
    }, [refresh]);
    return sliders;
};

export default useSliderList;

export const deleteSliders = async ({ id }: { id: number }, onSuccess: () => void) => {

    axios.get(`${URL_API}/slider-destroy/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`,
        }
    }).then(response => {

        if (response.status === 200) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.status === 405) {
            toast.info(error.response.data.message)
        }
    })

}

export const changeStatus = ({ id }: { id: number }, onSuccess: () => void) => {
    axios.get(`${URL_API}/slider-ChangeStatus/${id}`, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {
        if (response.status === 200) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 405) {
            toast.info(error.response.data.message)
        }
    })
}

